<template>
  <div class="items-not-found">
    <slot>{{ text }}</slot>
  </div>
</template>

<script>
export default {
  name: "ItemsNotFound",
  props: {
    text: {
      type: String,
      default: "Предметы не найдены"
    }
  }
};
</script>

<style lang="scss">
.items-not-found {
  font-size: 21px;
  font-weight: 500;
  text-align: center;
}
</style>
